import { useTranslation } from 'react-i18next'

interface Option {
  value: string
  label: string
}

interface FilterRadioGroupProps {
  options: Option[]
  value: string
  onChange: (value: string) => void
  columns?: 1 | 2
  name: string
}

const FilterRadioGroup = ({
  options,
  value,
  onChange,
  columns = 1,
  name,
}: FilterRadioGroupProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={
        columns === 2
          ? 'grid grid-cols-2 gap-x-4 gap-y-2'
          : 'flex flex-col gap-2'
      }
    >
      {options.map((opt) => (
        <label
          key={opt.value}
          className="flex items-center gap-2 cursor-pointer text-sm text-gray-800"
        >
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            className="w-4 h-4 border-gray-300 text-imovPrimary focus:ring-imovPrimary"
          />
          <span>{opt.label.includes('.') ? t(opt.label) : opt.label}</span>
        </label>
      ))}
    </div>
  )
}

export default FilterRadioGroup
